export const formatSeconds = (seconds: number): string => {
  if (isNaN(seconds)) return '';
  const secondsToDate = new Date(0);
  secondsToDate.setSeconds(seconds);
  return secondsToDate.toISOString().substr(11, 8);
};
